
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import lodash from "lodash";

lodash.templateSettings.interpolate = /{([\s\S]+?)}/g;

@Component
export default class RepeaterItemTitleText extends Vue {
  @Prop({
    default: ""
  })
  titleTemplate!: string;

  @Prop({
    default: "Item"
  })
  defaultTitle!: string;

  @Prop()
  value: object | undefined; /* should be a keyed object */

  get title() {
    // this regex removes whitespace. if the title template is "{some} {field}", the parsed title would be " "
    if (!this.parsedTitle.replace(/\s+/g, "")) {
      return this.defaultTitle;
    }

    return this.parsedTitle;
  }

  get compiledTemplate() {
    return lodash.template(this.titleTemplate);
  }

  get parsedTitle() {
    const initialVariables = this.getInitialVariables();
    const variables = Object.assign({}, initialVariables, this.value);
    return this.compiledTemplate(variables);
  }

  getVariablesInTitle() {
    // Finds all mustache {variables} inside a string.
    const matches = this.titleTemplate.matchAll(/{(.*?)}/g);

    // Returns an array of capture groups
    return Array.from(matches, m => m[1]);
  }

  getInitialVariables() {
    // Turns ['foo', 'bar'] into {foo: null, bar: null}
    return this.getVariablesInTitle().reduce(
      (ac, a) => ({ ...ac, [a]: null }),
      {}
    );
  }
}
